<template>
  <div class="const">
    <div style="padding:0 20px;margin-top:17px;">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        height="calc(100vh - 350px)"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <el-table-column prop="type" label="类型"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
      </el-table>
    </div>
    <div class="p_btns">
      <el-pagination
        small
        layout="prev, pager, next"
        :total="total"
        :page-size="pagesize"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { http } from "./../../https";
export default {
  data() {
    return {
      tableData: [],
      page: 0,
      pagesize: 8,
      total: 0,
      loading: false
    };
  },
  created() {
    this.tionSear();
  },
  methods: {
    tionSear() {
      const user_name = sessionStorage.getItem("user_name");
      const mac = sessionStorage.getItem("mac");
      const oauth_token = sessionStorage.getItem("oauth_token");
      let macSplit = mac.replace(/-/g, "");
      this.loading = true;
      const page = this.page;
      const pageSize = this.pagesize;
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getHardwareInfo&mac=${mac}&oauth_token=${oauth_token}&page=${page}&page_count=${pageSize}`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          this.loading = false;
          this.tableData = res.data.table;
          this.total = res.data.total;
        })
        .catch(res => {
          this.loading = false;
          console.log(res);
        });
    },
    handleCurrentChange(e) {
      this.page = e - 1;
      this.tionSear();
    }
  }
};
</script>
<style scoped>
.const {
  background: #ffffff;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  text-align: left;
  overflow: auto;
}
.const /deep/.el-table thead tr th {
  text-align: center;
  background: #e3e3e3;
  font-size: 18px;
  font-weight: 400;
  color: rgba(92, 91, 91, 1);
}
.const /deep/.el-table tbody tr td {
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
}
.const /deep/.el-table tbody tr td a {
  text-decoration: none;
  font-size: 13px;
  font-weight: 400;
  color: rgba(114, 166, 254, 1);
}
.const .p_btns {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}
.const .p_btns .hybb {
  margin-left: 20px;
  padding: 8px 44px;
  border: 1px solid rgba(40, 120, 255, 1);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  color: #2878ff;
  margin-right: 25px;
  cursor: pointer;
}
.const .p_btns .hybb:hover {
  background: #2878ff;
  color: #fff;
}
.const /deep/.el-pagination {
  text-align: right;
  margin-right: 20px;
}
</style>